import { Outlet } from '@tanstack/react-router'

import styles from './styles.module.css'

export function Layout() {
  return (
    <div className={styles.layout}>
      <Outlet />
    </div>
  )
}
